module.exports = __webpack_public_path__ + "static/media/10b94ba050aa8fa74073bfec8ea4688f.6b801fae.jpg";